module.exports = __webpack_public_path__ + "static/media/card-visa.654668a5.svg";